import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();

  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const element = document.querySelector(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleLogoClick = () => {
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 w-full border-b border-border-dark bg-background-dark/95 backdrop-blur-md">
      <div className="px-4 md:px-10 py-3 flex items-center justify-between max-w-[1200px] mx-auto">
        <Link to="/" className="flex items-center gap-3 text-white cursor-pointer" onClick={handleLogoClick}>
          <img src="/UPITrackrLogo.png" alt="UPI Trackr Logo" className="h-8 w-auto" />
          <h2 className="text-white text-xl font-bold leading-tight tracking-tight">UPI Trackr</h2>
        </Link>
        <div className="hidden md:flex items-center gap-8">
          <a className="text-white hover:text-primary transition-colors text-sm font-medium leading-normal cursor-pointer" onClick={(e) => handleSmoothScroll(e, '#features')}>Features</a>
          <a className="text-white hover:text-primary transition-colors text-sm font-medium leading-normal cursor-pointer" onClick={(e) => handleSmoothScroll(e, '#privacy')}>Security</a>
          <a className="text-white hover:text-primary transition-colors text-sm font-medium leading-normal cursor-pointer" onClick={(e) => handleSmoothScroll(e, '#how-it-works')}>How it Works</a>
          <a className="text-white hover:text-primary transition-colors text-sm font-medium leading-normal cursor-pointer" onClick={(e) => handleSmoothScroll(e, '#faq')}>FAQ</a>
        </div>
        <div className="flex items-center">
          <button className="flex min-w-[84px] cursor-pointer items-center justify-center overflow-hidden rounded-full h-10 px-6 bg-primary text-background-dark text-sm font-bold leading-normal tracking-[0.015em] hover:bg-opacity-90 transition-opacity">
            <span className="truncate">Download App</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
